export default __webpack_public_path__ + "static/media/manual01.5914f6de.png";